import React, { useEffect, createElement } from 'react';
export function MetaPixel() {
  useEffect(() => {
    const pixelId = '1252242806993118';
    // Guard: only init once
    // @ts-ignore
    if (window.fbq) {
      // @ts-ignore
      window.fbq('track', 'PageView');
      return;
    }
    // Manually create fbq queue (replicates FB Pixel base snippet safely)
    // @ts-ignore
    const n: any = function (...args: any[]) {
      // @ts-ignore
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
    };
    // @ts-ignore
    window.fbq = n;
    // @ts-ignore
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    // Append the FB events script safely to <head>
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    (document.head || document.documentElement).appendChild(script);
    // @ts-ignore
    window.fbq('init', pixelId);
    // @ts-ignore
    window.fbq('track', 'PageView');
  }, []);
  return null;
}